import { Markup } from '@/components/Markup';
import { LabradorComponent } from '@/types/component';
import { getViewportVisibilityClass } from '@/utils/getViewportVisibilityClass';
import { tw } from '@/utils/tw';
import { widthToClass } from '@/utils/widthToClass';

export const LabradorMarkup: LabradorComponent = ({ type, meta, data }) => {
  const widthClass = widthToClass(meta.width);

  const viewportVisibilityClass = getViewportVisibilityClass({
    viewportVisibility: meta.viewportVisibility,
    hideViewport: meta.hideViewport,
  });

  return (
    <Markup
      markup={data.markup}
      options={{ className: tw.join(widthClass, viewportVisibilityClass) }}
      data-content-index={meta.contentIndex}
    />
  );
};
